import React, { createContext, useContext } from 'react';
import { ChatSessionContextValue } from './types';
import { useChatSession } from './useChatSession';

const ChatWidgetContext = createContext<ChatSessionContextValue | null>(null);

export function useChatWidgetContext(): ChatSessionContextValue {
  const context = useContext(ChatWidgetContext);
  if (!context) {
    throw new Error('useChatWidgetContext must be used within ChatWidgetContextProvider');
  }
  return context;
}

export function ChatWidgetContextProvider(props: {
  conversationId?: number;
  children: React.ReactNode;
}) {
  const session = useChatSession(props.conversationId);

  return (
    <ChatWidgetContext.Provider value={session}>
      {props.children}
    </ChatWidgetContext.Provider>
  );
}
